<template>
    <div class="page-wrapper">
        <div class="page-content">
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                <div class="breadcrumb-title pe-3">FAQ Page</div>
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><router-link to="/home"><i class="bx bx-home-alt"></i></router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">FAQ Page CMS</li>
                        </ol>
                    </nav>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">FAQ Page CMS</h5>
                    <hr />
                    <div class="form-body mt-4">
                        <div class="row">
                            <div class="col-lg-8">
                                <div class="border border-3 p-4 rounded">
                                    <div class="mb-3">
                                        <label class="form-label">Page Title:</label>
                                        <input type="text" v-model="cmsData.pageTitle" class="form-control" placeholder="Enter Page Title" />
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label">Section Two Title:</label>
                                        <input type="text" v-model="cmsData.sectionTwoTitle" class="form-control" placeholder="Enter Section Two Title" />
                                    </div>
                                    <div class="col-12 mb-3">
                                        <label class="form-label">Section Two Subtitle:</label>
                                        <textarea type="text" v-model="cmsData.sectionTwoSubTitle" class="form-control" placeholder="Enter Section Two Subtitle" rows="3"></textarea>
                                    </div>
                                    <div class="d-grid">
                                        <button @:click="update()" type="button" class="btn btn-primary">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script src="../js/faq-page-cms.js"></script>